let heicToModule: typeof import("heic-to") | null = null;

const loadHeicTo = async (): Promise<typeof import("heic-to")> => {
  heicToModule ??= await import("heic-to");
  return heicToModule;
};

export const isHeicFile = async (file: File): Promise<boolean> => {
  try {
    const { isHeic } = await loadHeicTo();
    return await isHeic(file);
  } catch {
    return false;
  }
};

export const convertHeicToJpeg = async (blob: Blob): Promise<Blob> => {
  const { heicTo } = await loadHeicTo();
  return heicTo({
    blob,
    type: "image/jpeg",
    quality: 0.92
  });
};
